import { useState, useCallback } from 'react';
import { useSwipeable } from 'react-swipeable';

export const useSwipeHandler = (isMobile) => {
  const [activeColumn, setActiveColumn] = useState(1);

  // 모바일 스와이프 핸들러
  const handleSwipeLeft = useCallback(() => {
    if (!isMobile) return;
    const newColumn = Math.min(activeColumn + 1, 2);
    if (newColumn !== activeColumn) {
      // 햅틱 피드백 (iOS/Android)
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }
      setActiveColumn(newColumn);
    }
  }, [isMobile, activeColumn]);

  const handleSwipeRight = useCallback(() => {
    if (!isMobile) return;
    const newColumn = Math.max(activeColumn - 1, 0);
    if (newColumn !== activeColumn) {
      // 햅틱 피드백 (iOS/Android)
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }
      setActiveColumn(newColumn);
    }
  }, [isMobile, activeColumn]);

  // 스와이프 설정
  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleSwipeLeft,
    onSwipedRight: handleSwipeRight,
    trackMouse: false, // 마우스 드래그는 비활성화 (모바일 전용)
    trackTouch: true,
    delta: 80, // 최소 80px 이동해야 스와이프 인식 (기존 50px에서 증가)
    preventScrollOnSwipe: false, // 세로 스크롤은 허용
    touchEventOptions: { passive: false },
    swipeDuration: 500, // 500ms 이내에 완료되어야 스와이프로 인식
    rotationAngle: 0, // 회전 각도 제한 없음
    // 스와이프 방향 감지를 더 엄격하게
    onSwiping: (eventData) => {
      // 세로 스크롤이 더 큰 경우 스와이프 무시
      const { deltaX, deltaY } = eventData;
      if (Math.abs(deltaY) > Math.abs(deltaX) * 0.8) {
        return false; // 세로 움직임이 가로 움직임의 80% 이상이면 스와이프 취소
      }
    },
    // 최소 속도 요구사항 추가
    velocity: 0.3 // 최소 속도 0.3 (기본값보다 높음)
  });

  return {
    activeColumn,
    setActiveColumn,
    swipeHandlers,
    handleSwipeLeft,
    handleSwipeRight
  };
}; 